import * as React from 'react';

import { AuthContextProvider } from './context/AuthContext';
import { notifier } from '@blum-rivendell/reactui';
import ProtectRouteAuth from './hoc/ProtectRouteAuth';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AntdRegistry } from '@ant-design/nextjs-registry';
import { App, ConfigProvider } from 'antd';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const Providers = ({ children }: { children?: React.ReactNode }) => {
  return (
    <AntdRegistry>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#00cc99',
          },
        }}
      >
        <App>
          <QueryClientProvider client={queryClient}>
            <AuthContextProvider>
              <ProtectRouteAuth>
                <notifier.NotificationContextProvider>
                  <notifier.Notification />
                  {children}
                </notifier.NotificationContextProvider>
              </ProtectRouteAuth>
            </AuthContextProvider>
          </QueryClientProvider>
        </App>
      </ConfigProvider>
    </AntdRegistry>
  );
};

export default Providers;
